
import React from "react";
import { Link } from "react-router-dom";

import { useChat } from '../../../Hooks/UseChat';
import useTranslation from "../../../Hooks/UseTranslation";

import TreeProjectItem from "../ChatProjectsTreeItem/TreeProjectItem";

import "./ChatProjectsTree.scss";

interface Props {
  onSelectItem?: () => void;
  embedded?: boolean;
  searchQuery?: string;
}

const ChatProjectsTree = ({ onSelectItem, embedded, searchQuery = '' }: Props) => {

  const { t } = useTranslation();

  const { projectsTree } = useChat()

  const [ showprojects, setShowprojects ] = React.useState(false)

  const search = searchQuery.trim().toLowerCase()

  const filteredProjects = React.useMemo(() => {

    if (!search) return projectsTree

    return projectsTree
      .map((project: any) => {
        const projectMatches = project.name?.toLowerCase().includes(search)
        const teams = projectMatches
          ? project.teams
          : project.teams
            ?.map((team: any) => {
              const teamMatches = team.name?.toLowerCase().includes(search)
              const users = teamMatches
                ? team.users
                : team.users?.filter((user: any) => (
                  `${user.name || ''} ${user.surname || ''} ${user.email || ''}`.toLowerCase().includes(search)
                ))

              return {
                ...team,
                users: users || [],
                visible: teamMatches || !!users?.length,
              }
            })
            .filter((team: any) => team.visible)

        return {
          ...project,
          teams: teams || [],
          visible: projectMatches || !!teams?.length,
        }
      })
      .filter((project: any) => project.visible)
  }, [ projectsTree, search ])

  const handleSelectChat = () => {

    setShowprojects(false)

    if (onSelectItem) onSelectItem();
  }

  return (
    <div className={`chat-projects-tree ${showprojects && 'open'} ${embedded && 'embedded'}`}>
      {/* <button className="chat-projects-pl4nner-ai cursor-pointer"
        onClick={() => setShowprojects(!showprojects)}
      >
        Planner AI
      </button> */}
      {!embedded && (
        <button className="chat-projects-tree-toggler cursor-pointer"
          onClick={() => setShowprojects(!showprojects)}
        >
          {t('CHAT:SidebarTitle')} <i className="fas fa-chevron-up"></i>
        </button>
      )}

      <div className={`chat-projects-tree-content ${!filteredProjects.length && 'empty'}`}>
        {!filteredProjects.length && (
          <>
            {t('CHAT:SidebarNoProjectsYetOne')} <br />
            {t('CHAT:SidebarNoProjectsYetTwo')} <Link to='/'>{t('CHAT:SidebarNoProjectsYetThree')}</Link>
          </>
        )}
        {filteredProjects.map((project: any, index: number) => (
          <TreeProjectItem
            key={project._id}
            project={project}
            onSelectItem={() => handleSelectChat()}
          />
        ))}
      </div>
    </div>
  )
}

export default ChatProjectsTree;
